<template>
  <div class="ota-video-component text-gray-600" :class="{ 'no-square': noSquare }">
    <div class="responsive-square w-full relative">
      <div
        class="absolute w-full h-full"
        @click="playPauseVideo"
      >
        <video
          v-if="videoSource"
          ref="video"
          aria-hidden="true"
          class="absolute w-full h-full cursor-pointer object-cover"
          @ended="onEnd"
        >
          <source :src="videoSource" type="video/mp4">
        </video>
        <div
          v-if="placeholderImage && showPlaceHolder"
          class="absolute w-full h-full top-0 flex justify-center items-center"
        >
          <!-- TODO Dynamic alt tag (e.g. Glory video poster )-->
          <OImage
            v-if="placeHolderImageIsObject"
            class="w-full h-full"
            img-class="w-full h-full object-cover"
            v-bind="placeholderImage"
            :alt="$t('Accessibilty.AltTags.VideoPoster')"
          />
          <OImage
            v-else
            class="w-full h-full"
            img-class="w-full h-full object-cover"
            :desktop="placeholderImage"
            :mobile="placeholderImage"
            :src="placeholderImage"
            :alt="$t('Accessibilty.AltTags.VideoPoster')"
          />
        </div>
        <div
          v-if="videoSource && !isPlaying"
          class="absolute w-full h-full top-0 flex justify-center items-center cursor-pointer"
        >
          <OImage
            :desktop="customPlayButton ? customPlayButton.desktop : playButtonImage.desktop"
            :mobile="customPlayButton ? customPlayButton.mobile : playButtonImage.mobile"
            :src="customPlayButton ? customPlayButton.src : playButtonImage.src"
            :alt="$t('Accessibilty.AltTags.PlayButton')"
          />
        </div>
      </div>
    </div>
    <Socials
      v-if="!hideInfoText"
      class="px-5 negative-margin relative"
      :hide-socials="hideSocials"
    />
  </div>
</template>

<script>
import { convertSrcSet } from '@/utils/general'
const OImage = () => import('@/components/OImage')
const Socials = () => import('@/components/Socials')

export default {
  name: 'VideoComponent',
  components: {
    Socials,
    OImage
  },
  props: {
    videoSource: {
      type: String,
      default: ''
    },
    placeholderImage: {
      type: [String, Object],
      default: ''
    },
    customPlayButton: {
      type: Object,
      default: null
    },
    hideInfoText: {
      type: Boolean,
      default: false
    },
    hideSocials: {
      type: Boolean,
      default: false
    },
    showVideoControls: {
      type: Boolean,
      default: false
    },
    noSquare: {
      type: Boolean,
      default: false
    },
    playFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isPlaying: false,
      hasPlayed: false
    }
  },
  computed: {
    playButtonImage () {
      return convertSrcSet({
        mobile: {
          '1x': '/img/homepage/play-button-mob.webp',
          '2x': '/img/homepage/play-button-mob@2x.webp'
        },
        desktop: {
          '1x': '/img/homepage/play-button.webp',
          '2x': '/img/homepage/play-button@2x.webp'
        }
      })
    },
    placeHolderImageIsObject () {
      return (this.placeholderImage.mobile && this.placeholderImage.desktop)
    },
    showPlaceHolder () {
      return !this.videoSource || (this.placeholderImage && !this.hasPlayed)
    }
  },
  watch: {
    isPlaying (isPlaying) {
      if (this.showVideoControls) {
        if (isPlaying) {
          this.$refs.video.controls = true
        } else {
          this.$refs.video.controls = false
        }
      }
    }
  },
  methods: {
    playPauseVideo () {
      if (!this.videoSource) {
        return
      }

      if (!this.hasPlayed) {
        this.hasPlayed = true
      }

      if (this.isPlaying) {
        this.$refs.video.pause()
        this.$emit('pause')
      } else {
        if (this.playFullscreen) {
          try {
            this.$refs.video.requestFullscreen()
          } catch (error) {
            this.$ota.general.logError(error)
          }
        }

        this.$refs.video.play()

        this.$emit('play')
      }

      this.isPlaying = !this.isPlaying
    },
    onEnd () {
      this.playPauseVideo()
      this.hasPlayed = false
    }
  }
}
</script>

<style lang="postcss" scoped>
@media (max-width: 400px) {
  .ota-title {
    @apply text-2xl !important;
  }
}

>>> .object-cover {
  @apply object-cover !important;
}

.responsive-square:after {
  @apply block;
  content: "";
  padding-bottom: 100%;
}

.oimage >>> img {
  max-width: 100% !important;
}

.negative-margin {
  margin-top: -3rem;
}

@screen md {
  .negative-margin {
    margin-top: -7.3rem;
  }
}

.no-square {
  .responsive-square {
    @apply h-full;

    video {
      @apply object-fill relative !important;
    }

    &:after {
      content: none;
    }

    > div {
      @apply relative;
    }
  }
}
</style>
